import { MEMBER_UPDATE_SUCCESSFUL } from '@api/Statuses';
import MemberEditApi from '@api/MemberEditApi';
import MemberApi from '@api/MemberApi';
import router from '@/router';
import * as actionTypes from './actionTypes';
import * as mutationTypes from './mutationTypes';
import { memberUpdateAdapter } from './adapters';
import { fixPagrParams  } from '@utils';
import { convertAddressType } from '../../../utils';

export default {
  [actionTypes.GET_MEMBER_DETAILS](context, options = {}) {
    context.commit(mutationTypes.BEGIN_LOADING_MEMBER_DETAILS)
    new MemberEditApi({
      simulateExample: 'Member Details-With eligibility & benefits'
    })
      .getMemberDetails({
        params: {
          memberCk: options.memberCk,
          ...options.params,
          ...router.currentRoute.query
        }
      })
      .then(memberDetails =>
        context.commit(mutationTypes.SET_MEMBER_DETAILS, memberDetails)
      )
      .catch(_ => {
        // todo
      })
  },

  [actionTypes.GET_MEMBER_ADDRESSES](context, options = {}) {
    context.commit(mutationTypes.BEGIN_LOADING_MEMBER_ADDRESSES)
    new MemberEditApi({ simulateExample: 'Get Member Address' })
      .getMemberAddresses({
        subscriberCk: options.memberCk
      })
      .then(memberAddresses =>
        context.commit('SET_MEMBER_ADDRESSES', memberAddresses)
      )
      .catch(_ => {
        // todo
      })
  },

  [actionTypes.GET_MEMBER_TRANSACTIONS](context, options = {}) {
    context.commit(mutationTypes.BEGIN_LOADING_MEMBER_TRANSACTIONS);
    let fetchOpts = {...context.rootGetters['groupSelector/selected'] };
    fetchOpts = fixPagrParams(fetchOpts);
    // fetchOpts.userId = '';
    // console.log(`fetchOpts`, fetchOpts);
    new MemberApi({
      simulateExample: 'Transaction History - Internal User - Update'
    })
      .transactionHistory({
        body: {
          ...context.rootGetters.queryParams,
          ...fetchOpts,
        }
      })
      .then(response => {
        if (Array.isArray(response)) { context.commit(mutationTypes.SET_MEMBER_TRANSACTIONS, response) } else { context.commit(mutationTypes.SET_MEMBER_TRANSACTIONS_ERROR, response) }
      })
      .catch(_ => {
        // todo
      })
  },

  [actionTypes.GET_MEMBER_TRANSACTION_DRAFTS](context, options = {}) {
    context.commit(mutationTypes.BEGIN_LOADING_MEMBER_TRANSACTIONS);
    // console.log(`get mem trans drafts`, options.params);
    new MemberApi({ simulateExample: 'Draft Trans - Subscriber' })
      .pendingMemberTransactions(options.params)
      .then(response =>
        context.commit(mutationTypes.SET_MEMBER_TRANSACTION_DRAFTS, response)
      )
      .catch(_ => {
        // todo
      })
  },

  [actionTypes.UPDATE_MEMBER](context, options = {}) {
    context.commit(mutationTypes.SET_UPDATING_MEMBER, true)
    let updateMemberPayload = memberUpdateAdapter(context.state)
    updateMemberPayload.transactionType = options.transactionType

    return new MemberApi({ simulateExample: 'Update Subscriber' })
      .updateMember({
        memberCk: options.memberCk,
        ...updateMemberPayload
      })
      .then(response => {
        if (response.status === MEMBER_UPDATE_SUCCESSFUL) { context.commit('SET_ANNOUNCEMENT', 'Member updated') }
      })
      .catch(_ => {
        // todo
      })
      .finally(() => {
        context.commit(mutationTypes.SET_UPDATING_MEMBER, false)
      })
  },

  [ actionTypes.GET_MEMBER_TRANSACTION_DETAILS ] (context, options = {}) {
    context.commit(mutationTypes.SET_MEMBER_TRANSACTION_DETAILS_LOADING, true);
    // console.log(`get mem trans deets`, options);
    return new MemberApi()
      .getPendingMemberTransactionDetails({
        params: options.params,
        transactionId: options.transactionId
      })
      .then(memberTransactionDetails =>
        context.commit(mutationTypes.SET_MEMBER_DETAILS, memberTransactionDetails)
      )
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        context.commit(mutationTypes.SET_MEMBER_TRANSACTION_DETAILS_LOADING, false)
      })
  }
}
